import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TrsUrlImport',
    props: {
        queryTrsUrl: {
            type: String,
            default: null,
        },
    },
    emits: ["onImport"],
    setup(__props, { emit }) {
        const props = __props;
        const trsUrl = ref(props.queryTrsUrl);
        const isImportDisabled = computed(() => {
            return !trsUrl.value;
        });
        const importTooltip = computed(() => {
            return isImportDisabled.value ? "You must provide a TRS URL." : "Import workflow from TRS URL";
        });
        function submit(ev) {
            ev.preventDefault();
            emit("onImport", trsUrl.value);
        }
        // Automatically trigger the import if the TRS URL was provided as a query param
        if (trsUrl.value) {
            emit("onImport", trsUrl.value);
        }
        return { __sfc: true, props, trsUrl, isImportDisabled, importTooltip, emit, submit };
    }
});
